"use client";

import ScheduleAnAppointmentForm from "@/components/forms/ScheduleAnAppointmentForm";
import Section from "../components/Section";
import {
  Calendar,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  Grid2,
  TimeSlotPicker,
  Typography,
} from "@repo/ui";

import { useEffect, useState } from "react";
import moment from "moment";

type KnowBenefitsOfSpoclearnProps = {
  sectionInfo: PageSections;
  data: {
    serviceId: string;
    heading?: string;
    description?: string;
    buttonText?: string;
  };
};

const KnowBenefitsOfSpoclearn = ({
  sectionInfo,
  data,
}: KnowBenefitsOfSpoclearnProps) => {
  const [date, setDate] = useState<Date | undefined>();
  const [time, setTime] = useState("");
  const [open, setOpen] = useState(false);

  // Calculate tomorrow's date at midnight
  const tomorrow = new Date();
  tomorrow.setHours(0, 0, 0, 0);
  tomorrow.setDate(tomorrow.getDate() + 1);

  useEffect(() => {
    if (date && time) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [date, time]);

  return (
    <Section id={sectionInfo.sectionId} className={sectionInfo.sectionClass}>
      <Card>
        <CardHeader className="!bg-blue-100">
          <Typography variant="h2" gutterBottom>
            {data.heading || `Let’s Talk – Schedule a Time That Works for You`}
          </Typography>
          <Typography paragraph className="!text-gray-500 !text-lg">
            {data.description ||
              `We know your time matters. Use the calendar below to book a
            consultation with our team at your convenience—adjusted to your
            timezone. Let’s explore how Spoclearn can help you transform and
            grow.`}
          </Typography>
        </CardHeader>
        <CardContent>
          <Grid2 container spacing={5}>
            <Grid2 size={{ sm: 12, md: 5, lg: 5 }}>
              <Typography variant="h3" className="mb-6">
                Select a date & time
              </Typography>

              <Calendar
                onChange={setDate}
                value={date}
                size="small"
                className="!shadow-none sm:[&_*_td>button]:!size-10 !max-w-[unset]"
                disabled={{ before: tomorrow }}
              />
            </Grid2>
            <Grid2 size={{ sm: 12, md: 7, lg: 7 }}>
              <TimeSlotPicker
                selectedDate={date}
                selectedTime={time}
                onTimeSelect={(newTime) => setTime(newTime)}
              />
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>
      {/* Schedule an appointment popup form  */}
      <Dialog
        open={open}
        onOpenChange={setOpen}
        maxWidth="sm"
        title="Schedule an appointment"
      >
        <ScheduleAnAppointmentForm
          date={date instanceof Date ? moment(date).format("YYYY-MM-DD") : ""}
          time={time}
          serviceId={data?.serviceId}
          onSuccess={() => setOpen(false)}
        />
      </Dialog>
    </Section>
  );
};

export default KnowBenefitsOfSpoclearn;
